import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { HOURS } from "../constants";

// Ported from nuvven-b2b-app's sx-based (MUI v5) design — converted to v4's makeStyles/JSS
// since b2b2c only has @material-ui/core v4 installed. Spacing/radius values below are literal
// pixels pre-computed from the original sx shorthand (e.g. sx's `px: 2` = 16px) rather than
// theme.spacing(), because this app's theme overrides the spacing unit to 10px (see
// components/Theme/index.ts) — using theme.spacing() here would silently resize everything.
const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: 24,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    gap: 8,
    backgroundColor: "var(--brand-accent)",
    color: "#fff",
    borderRadius: 16,
    boxShadow: theme.shadows[8],
    border: "1px solid rgba(255,255,255,0.1)",
    padding: "12px 16px",
  },
  icon: {
    fontSize: 16,
    color: "var(--primary-color)",
    flexShrink: 0,
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: "rgba(255,255,255,0.75)",
    marginRight: 4,
    whiteSpace: "nowrap",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  divider: {
    width: 1,
    height: 20,
    backgroundColor: "rgba(255,255,255,0.2)",
    margin: "0 4px",
  },
  hourButton: {
    fontSize: 13,
    padding: "6px 14px",
    borderRadius: 12,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    transition: "all 0.15s",
    backgroundColor: "transparent",
    color: "rgba(255,255,255,0.75)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.15)",
      color: "#fff",
    },
  },
  hourButtonActive: {
    backgroundColor: "var(--primary-color)",
    color: "var(--brand-accent)",
    boxShadow: theme.shadows[2],
    transform: "scale(1.05)",
    "&:hover": {
      backgroundColor: "var(--primary-color)",
      color: "var(--brand-accent)",
    },
  },
}));

interface TrackingHistoryBarProps {
  selected: number | null;
  onChange: (hours: number) => void;
}

export function TrackingHistoryBar({ selected, onChange }: TrackingHistoryBarProps) {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <AccessTimeIcon className={classes.icon} />
      <Typography className={classes.label}>Tracking History</Typography>
      <Box className={classes.divider} />
      {HOURS.map((h) => (
        <Box
          key={h}
          component="button"
          onClick={() => onChange(selected === h ? 0 : h)}
          className={`${classes.hourButton} ${selected === h ? classes.hourButtonActive : ""}`}
        >
          {h}h
        </Box>
      ))}
    </Box>
  );
}
